<template>
  <Modal
    v-model="_value"
    width="800"
    ok-text="修改"
    cancel-text="关闭"
    @on-ok="onOk"
    @on-visible-change="visibleChange"
    title="运输车辆信息分组详细信息">
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="分组名称">
        <Input v-model="transportVehicleInfoGroup.name" placeholder="分组名称"></Input>
      </Form-item>
      <Form-item label="父级分组" required>
<!--        <Input :readonly="true" v-model="transportVehicleInfoGroup.parentGroupId" placeholder="父级分组"></Input>-->
        <Select style="display: inline-block; width: 200px;"
                v-model="transportVehicleInfoGroup.parentGroupId"
                filterable
                clearable
                remote
                :remote-method="searchGroup"
                :loading="searchGroupLoading">
          <Option v-for="(option, index) in searchGroupList" :value="option.id" :key="option.id">{{option.name}}</Option>
        </Select>
        <Button type="primary" style="display: inline-block; margin-left: 5px;" @click="onClear">清空</Button>
      </Form-item>
      <Form-item label="备注">
        <Input v-model="transportVehicleInfoGroup.remark" placeholder="备注" type="textarea" style="width: 100%;"></Input>
      </Form-item>
      <Form-item label="描述">
        <Input v-model="transportVehicleInfoGroup.description" placeholder="描述" type="textarea" style="width: 100%;"></Input>
      </Form-item>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'transportvehicleinfogroupdetailmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {

      searchGroupValue: null,
      searchGroupLoading: false,
      searchGroupList: [],

      transportVehicleInfoGroup: {
        id: null,
        name: null,
        parentGroupId: null,
        parentGroup: null,
        remark: null,
        description: null
      }
    }
  },
  methods: {
    ...mapActions([
      'TransportVehicleInfoGroupServ_AddObj'
    ]),
    onClear () {
      this.transportVehicleInfoGroup.parentGroupId = null
    },
    searchGroup (input) {
      console.log(input)
      this.searchGroupLoading = true
      if (!input || input.length <= 0) {
        this.searchGroupList = []
        this.searchGroupLoading = false
      } else {
        store.dispatch('TransportVehicleInfoGroupServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchGroupList = store.getters.get_TransportVehicleInfoGroup_SearchByNameResult ? store.getters.get_TransportVehicleInfoGroup_SearchByNameResult : []
          this.searchGroupLoading = false
        }).catch(err => {
          this.searchGroupLoading = false
        })
      }
    },
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认修改</p>',
        onOk: () => {
          store.dispatch('TransportVehicleInfoGroupServ_ModifyObj', {
            params: this.transportVehicleInfoGroup
          }).then(() => {
            this.$Message.success('修改成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.transportVehicleInfoGroup.id = null
        this.transportVehicleInfoGroup.name = null
        this.transportVehicleInfoGroup.parentGroupId = null
        this.transportVehicleInfoGroup.description = null
        this.transportVehicleInfoGroup.remark = null

        store.dispatch('TransportVehicleInfoGroupServ_GetDetail', {
          params: { id: this._initValue }
        }).then(() => {
          this.transportVehicleInfoGroup = store.getters.get_TransportVehicleInfoGroup_GetDetailResult
          if (this.transportVehicleInfoGroup.parentGroup) {
            this.searchGroup(this.transportVehicleInfoGroup.parentGroup.name)
            store.dispatch('TransportVehicleInfoGroupServ_GetDetail', {
              params: { id: this._initValue }
            }).then(() => {
              this.transportVehicleInfoGroup = store.getters.get_TransportVehicleInfoGroup_GetDetailResult
            }).catch(err => {
              this.$Message.error(err)
            })
          } else {
            this.transportVehicleInfoGroup = store.getters.get_TransportVehicleInfoGroup_GetDetailResult
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
